import ExpertExtraIcon from 'img/icons/offering_icons/expertextras_icon.svg';
import {
  BodyRowType,
  HeaderIconConfig,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import { formatProductRows } from '../BodyBuilder/utils';

const expertSeminarIconConfig: HeaderIconConfig = {
  backgroundColor: '#5073B0',
  iconTitle: 'Delivery format: Expert Extra',
  src: ExpertExtraIcon,
};

const expertSeminarConfig: OfferingTypeConfig = {
  actionButtons: ({ displayProgress, entry, catalogStore, t }) => {
    const link = catalogStore.getCatalogEntryLink(entry);
    if (!link) {
      return {};
    }

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: link.href,
        icon: IconType.Arrow,
        onClick: link.navigate,
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Icons, BodyRowType.Custom],
  buildCustomRows: ({ offeringProducts, offeringTopics }) =>
    formatProductRows([...offeringProducts, ...offeringTopics]),
  headerConfig: ({ t }) => ({
    iconB: expertSeminarIconConfig,
    title: t('Expert extra'),
  }),
  iconRowsLayout: () => [[IconLabel.Duration]],
};

export default expertSeminarConfig;
